


// #############################################

// import HttpService from "./htttp.service";

// class SearchService {
//   /**
//    * Search across all or specific platforms, in parallel for faster results.
//    * @param {string} query - Search keyword (e.g., 'tesla')
//    * @param {string|null} platform - Optional ('Facebook' | 'YouTube' | 'Instagram')
//    * @param {boolean} isTrending - Optional flag to fetch trending results (default: false)
//    */
//   async searchAllPlatforms(query, platform = null, isTrending = false) {
//     try {
//       // Normalize query before sending
//       const normalizedQuery = (query || "")
//         .trim()
//         .replace(/^@/, "")     // Remove '@' if it’s the first character
//         .replace(/\s+/g, "")   // Remove all spaces between words
//         .toLowerCase();        // Convert to lowercase

//       const searchPromises = [];

//       // ✅ Prepare platform search promises (run all in parallel)
//       if (!platform || platform === "Facebook") {
//         searchPromises.push(
//           this.searchFacebook(normalizedQuery, isTrending)
//             .then((res) =>
//               (res.data || []).map((item) => ({
//                 ...item,
//                 platform: "Facebook",
//                 isTrending,
//               }))
//             )
//             .catch((error) => {
//               console.error("❌ Error fetching Facebook data:", error);
//               return [];
//             })
//         );
//       }

//       if (!platform || platform === "YouTube") {
//         searchPromises.push(
//           this.searchYouTube(normalizedQuery, isTrending)
//             .then((res) =>
//               (res.data || []).map((item) => ({
//                 ...item,
//                 platform: "YouTube",
//                 isTrending,
//               }))
//             )
//             .catch((error) => {
//               console.error("❌ Error fetching YouTube data:", error);
//               return [];
//             })
//         );
//       }

//       if (!platform || platform === "Instagram") {
//         searchPromises.push(
//           this.searchInstagram(normalizedQuery, isTrending)
//             .then((res) =>
//               (res.data || []).map((item) => ({
//                 ...item,
//                 platform: "Instagram",
//                 isTrending,
//               }))
//             )
//             .catch((error) => {
//               console.error("❌ Error fetching Instagram data:", error);
//               return [];
//             })
//         );
//       }

//       // ✅ Run all searches in parallel
//       const results = await Promise.allSettled(searchPromises);

//       // ✅ Combine fulfilled responses (ignore failed ones)
//       const allResults = results
//         .filter((r) => r.status === "fulfilled")
//         .flatMap((r) => r.value);

//       console.log(
//         `✅ Completed parallel search. Total results: ${allResults.length}`
//       );

//       return allResults;
//     } catch (error) {
//       console.error("🔥 Fatal error searching platforms:", error);
//       throw error;
//     }
//   }

//   /**
//    * Platform-specific search endpoints
//    */
//   searchFacebook(query, isTrending = false) {
//     const payload = {
//       data: {
//         type: "search",
//         attributes: { query, isTrending },
//       },
//     };
//     return HttpService.post("/platform/facebook/search", payload);
//   }

//   searchYouTube(query, isTrending = false) {
//     const payload = {
//       data: {
//         type: "search",
//         attributes: { query, isTrending },
//       },
//     };
//     return HttpService.post("/platform/youtube/search", payload);
//   }

//   searchInstagram(query, isTrending = false) {
//     const payload = {
//       data: {
//         type: "search",
//         attributes: { query, isTrending },
//       },
//     };
//     return HttpService.post("/platform/instagram/search", payload);
//   }
// }

// export default new SearchService();


// ################################################

import HttpService from "./htttp.service";

class SearchService {
  /**
   * Search across all or specific platforms, in parallel for faster results.
   * @param {string} query - Search keyword (e.g., 'tesla')
   * @param {string|null} platform - Optional ('Facebook' | 'YouTube' | 'Instagram')
   * @param {boolean} isTrending - Optional flag to fetch trending results (default: false)
   * @param {string|null} clientId - Optional WebSocket client ID
   */
  async searchAllPlatforms(query, platform = null, isTrending = false, clientId = null) {
    try {
      // ✅ Normalize query before sending
      const normalizedQuery = (query || "")
        .trim()
        .replace(/^@/, "")    // Remove leading '@'
        // .replace(/\s+/g, "")  // Remove all spaces
        .toLowerCase();       // Convert to lowercase

      const searchPromises = [];

      // ✅ Facebook
      if (!platform || platform === "Facebook") {
        searchPromises.push(
          this.searchFacebook(normalizedQuery, isTrending, clientId)
            .then((res) =>
              (res.data || []).map((item) => ({
                ...item,
                platform: "Facebook",
                isTrending,
              }))
            )
            .catch((error) => {
              console.error("❌ Error fetching Facebook data:", error);
              return [];
            })
        );
      }

      // ✅ YouTube
      if (!platform || platform === "YouTube") {
        searchPromises.push(
          this.searchYouTube(normalizedQuery, isTrending, clientId)
            .then((res) =>
              (res.data || []).map((item) => ({
                ...item,
                platform: "YouTube",
                isTrending,
              }))
            )
            .catch((error) => {
              console.error("❌ Error fetching YouTube data:", error);
              return [];
            })
        );
      }

      // ✅ Instagram
      if (!platform || platform === "Instagram") {
        searchPromises.push(
          this.searchInstagram(normalizedQuery, isTrending, clientId)
            .then((res) =>
              (res.data || []).map((item) => ({
                ...item,
                platform: "Instagram",
                isTrending,
              }))
            )
            .catch((error) => {
              console.error("❌ Error fetching Instagram data:", error);
              return [];
            })
        );
      }

      // ✅ Run all in parallel (still needed as fallback)
      const results = await Promise.allSettled(searchPromises);

      // ✅ Combine fulfilled responses (WebSocket may also stream separately)
      const allResults = results
        .filter((r) => r.status === "fulfilled")
        .flatMap((r) => r.value);

      // console.log(`✅ Completed parallel search. Total results: ${allResults.length}`);
      return allResults;
    } catch (error) {
      console.error("🔥 Fatal error searching platforms:", error);
      throw error;
    }
  }

  // ✅ Platform-specific POSTs (now with optional clientId)
  searchFacebook(query, isTrending = false, clientId = null) {
    const payload = {
      data: {
        type: "search",
        attributes: { query, isTrending, clientId },
      },
    };
    return HttpService.post("/platform/facebook/search", payload);
  }

  searchYouTube(query, isTrending = false, clientId = null) {
    const payload = {
      data: {
        type: "search",
        attributes: { query, isTrending, clientId },
      },
    };
    return HttpService.post("/platform/youtube/search", payload);
  }

  searchInstagram(query, isTrending = false, clientId = null) {
    const payload = {
      data: {
        type: "search",
        attributes: { query, isTrending, clientId },
      },
    };
    return HttpService.post("/platform/instagram/search", payload);
  }
}

export default new SearchService();
